(function () {
  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function getTzParts(timeZone, date = new Date()) {
    const dtf = new Intl.DateTimeFormat("en-GB", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hourCycle: "h23",
    });

    const parts = dtf.formatToParts(date);
    const map = {};
    for (const p of parts) {
      if (p.type !== "literal") map[p.type] = p.value;
    }

    return {
      year: Number(map.year),
      month: Number(map.month),
      day: Number(map.day),
      hour: Number(map.hour),
      minute: Number(map.minute),
      second: Number(map.second),
    };
  }

  function getOffsetMinutes(timeZone, date) {
    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone,
      timeZoneName: "shortOffset",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    }).formatToParts(date);

    const tzName = parts.find((p) => p.type === "timeZoneName")?.value || "GMT";
    const m = tzName.match(/GMT([+-])(\d{1,2})(?::?(\d{2}))?/);

    if (!m) return 0;

    const sign = m[1] === "-" ? -1 : 1;
    const hours = Number(m[2] || 0);
    const mins = Number(m[3] || 0);

    return sign * (hours * 60 + mins);
  }

  function makeTzDate(timeZone, y, m, d, hh, mm, ss) {
    const utcGuess = new Date(Date.UTC(y, m - 1, d, hh, mm, ss || 0));
    const offsetMin = getOffsetMinutes(timeZone, utcGuess);
    return new Date(utcGuess.getTime() - offsetMin * 60 * 1000);
  }

  function initCountdown(el) {
    const cutoffHour = Number(el.dataset.cutoffHour || 22);
    const cutoffMinute = Number(el.dataset.cutoffMinute || 0);
    const timeZone = el.dataset.timezone || "Europe/London";
    const showWhenHoursLeft = Number(el.dataset.showWhenHoursLeft || 24);

    const prefix = el.querySelector(".prc-prefix");
    const timeEl = el.querySelector(".prc-time");
    const suffix = el.querySelector(".prc-suffix");

    if (prefix) prefix.textContent = el.dataset.messageBefore || "Order within";
    if (suffix) suffix.textContent = el.dataset.messageAfter || "for the next print run";

    function tick() {
      const now = new Date();
      const nowTz = getTzParts(timeZone, now);

      let target = makeTzDate(
        timeZone,
        nowTz.year,
        nowTz.month,
        nowTz.day,
        cutoffHour,
        cutoffMinute,
        0
      );

      if (now.getTime() >= target.getTime()) {
        const tomorrow = new Date(now.getTime() + 24 * 60 * 60 * 1000);
        const tomTz = getTzParts(timeZone, tomorrow);

        target = makeTzDate(
          timeZone,
          tomTz.year,
          tomTz.month,
          tomTz.day,
          cutoffHour,
          cutoffMinute,
          0
        );
      }

      const diff = Math.max(0, target.getTime() - now.getTime());
      const showThresholdMs = showWhenHoursLeft * 60 * 60 * 1000;

      if (diff <= showThresholdMs) {
        el.style.display = "";
      } else {
        el.style.display = "none";
      }

      const totalSeconds = Math.floor(diff / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (timeEl) {
        timeEl.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      }

      if (diff <= 60 * 60 * 1000) el.classList.add("prc-urgent");
      else el.classList.remove("prc-urgent");
    }

    tick();
    setInterval(tick, 1000);
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".print-run-countdown").forEach(initCountdown);
  });
})();